module.exports = __webpack_public_path__ + "img/image38.369c1304.png";